import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loading-container text-center"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "loading-body" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "lds-ripple" }, [
    /*#__PURE__*/_createElementVNode("div"),
    /*#__PURE__*/_createElementVNode("div")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "loading-txt text-center" }, " Loading ... ")
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 0,
  class: "main-container"
}
const _hoisted_5 = { class: "toolbar-and-workspace" }
const _hoisted_6 = { class: "toolbar-container" }
const _hoisted_7 = { class: "workspace-container" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h3", null, "Session detected", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", null, " Resume Arweave Web Wallet session? ", -1)
const _hoisted_10 = { class: "modal-footer text-right" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "Resume session", -1)
const _hoisted_12 = [
  _hoisted_11
]

import { ref, onMounted } from 'vue';
import DefaultWorkspace from '@/components/composed/DefaultWorkspace.vue';
import MainToolbar from '@/components/composed/MainToolbar.vue';
import StatusBar from '@/components/atomic/StatusBar.vue';
import { UserSettings } from '@/core/UserSettings';
// import { ArweaveWrapper } from '@/core/ArweaveWrapper';
// import { WarpContracts } from '@/core/WarpContracts';
import { IFrameWalletBridge } from '@/core/IFrameWalletBridge';
import { createToast } from 'mosha-vue-toastify';
import { Login } from '@/core/Login';
import DefaultModal from '@/components/atomic/DefaultModal.vue';
// import { tokenContract } from '@/core/contracts/ArcodeCommunity';
import LoadContractFromTxDialog from '@/components/dialogs/LoadContractFromTxDialog';
import LoadWorkspaceFromTxDialog from '@/components/dialogs/LoadWorkspaceFromTxDialog';


export default /*#__PURE__*/_defineComponent({
  __name: 'HomePage',
  props: {
  tx: String,
  hideToolbar: Boolean,
  theme: String,
  networkParam: String,
  workspaceParam: String
},
  setup(__props) {

const props = __props;



const us: UserSettings = new UserSettings();
const settings = us.settings;
const theme = ref(settings.theme);
// const arweaveWrapper = new ArweaveWrapper();
// const arweave = arweaveWrapper.arweave;
// const warp = new WarpContracts(arweave);
const login = new Login();
const workspace = ref(null);
const loadingAppContract = ref(true);
const tokenState = ref({});
const showModalArweaveWebWallet = ref(false);
const showLoadContractFromTxDialog = ref(false);
const showLoadWorkspaceFromTxDialog = ref(false);


// const tx = ref(route.params.tx);
// const tx = ref(props.tx);
const iframe = ref(false);


onMounted(async () => {
  try {
    // Set theme 
    // Check first URL parameter
    if (props.theme) {
      try {
        const t = props.theme === 'default' ? '' : props.theme;
        us.setAppTheme(t);
        theme.value = t;
      } catch (err) {
        console.error(`Theme: ${err}`)
      }
    } else {
      us.setAppTheme(theme.value);
    }

    // Load PST contract state
    // Disabled to allow Free usage 
    /*
    loadingAppContract.value = true;
    try {
      const { cachedValue } = await warp.readState(tokenContract);
      const state = cachedValue &&
        Object.prototype.hasOwnProperty.call(cachedValue, 'state') ?
        cachedValue.state : {};
      tokenState.value = state;
    } catch (err) {
      console.log('PSTError', err)
    }
    */
    loadingAppContract.value = false;

    // Is editor inside an iframe?
    const iframeBridge = new IFrameWalletBridge();
    iframe.value = iframeBridge.start();

    // Load session data
    if (!iframe.value && !props.tx && !props.workspaceParam) {
      const sessInfo = login.loadSession(settings.stayLoggedIn);
      if (sessInfo.method === 'webwallet') {
        // Throw modal
        showModalArweaveWebWallet.value = true;
        // await login.arweaveWebWallet(settings.stayLoggedIn, arweave);
      }
    }

  } catch (err) {
    createToast(`mount: ${err}`,
    {
      type: 'danger',
      showIcon: true,
      position: 'bottom-right',
    });
    loadingAppContract.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, { name: "fadeSlow" }, {
      default: _withCtx(() => [
        (loadingAppContract.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fadeSlow" }, {
      default: _withCtx(() => [
        (!loadingAppContract.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(MainToolbar, {
                    iframe: iframe.value,
                    tx: __props.tx,
                    workspace: workspace.value,
                    hideToolbar: __props.hideToolbar,
                    login: _unref(login),
                    theme: theme.value,
                    tokenState: tokenState.value,
                    networkParam: __props.networkParam
                  }, null, 8, ["iframe", "tx", "workspace", "hideToolbar", "login", "theme", "tokenState", "networkParam"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(DefaultWorkspace, {
                    onOpenDialogLoadContractFromTx: _cache[0] || (_cache[0] = ($event: any) => (showLoadContractFromTxDialog.value = true)),
                    onOpenDialogLoadWorkspaceFromTx: _cache[1] || (_cache[1] = ($event: any) => (showLoadWorkspaceFromTxDialog.value = true)),
                    ref_key: "workspace",
                    ref: workspace,
                    tx: __props.tx,
                    networkParam: __props.networkParam,
                    theme: theme.value,
                    workspaceParam: __props.workspaceParam
                  }, null, 8, ["tx", "networkParam", "theme", "workspaceParam"])
                ])
              ]),
              _createVNode(StatusBar, { workspace: workspace.value }, null, 8, ["workspace"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (showModalArweaveWebWallet.value)
          ? (_openBlock(), _createBlock(DefaultModal, {
              key: 0,
              onClose: _cache[4] || (_cache[4] = ($event: any) => (showModalArweaveWebWallet.value = false))
            }, {
              header: _withCtx(() => [
                _hoisted_8
              ]),
              body: _withCtx(() => [
                _hoisted_9
              ]),
              footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("button", {
                    class: "modal-button modal-button-primary",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => {_unref(login).arweaveWebWallet(_unref(settings).stayLoggedIn); showModalArweaveWebWallet.value = false})
                  }, _hoisted_12),
                  _createElementVNode("button", {
                    class: "modal-button",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => {_unref(login).logout(); showModalArweaveWebWallet.value = false})
                  }, " Dismiss ")
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        _createVNode(_unref(LoadContractFromTxDialog), {
          show: showLoadContractFromTxDialog.value,
          workspace: workspace.value,
          tx: __props.tx,
          txField: __props.tx,
          networkParam: __props.networkParam,
          onClose: _cache[5] || (_cache[5] = ($event: any) => (showLoadContractFromTxDialog.value = false))
        }, null, 8, ["show", "workspace", "tx", "txField", "networkParam"])
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        _createVNode(_unref(LoadWorkspaceFromTxDialog), {
          show: showLoadWorkspaceFromTxDialog.value,
          workspace: workspace.value,
          tx: __props.workspaceParam,
          txField: __props.workspaceParam,
          networkParam: __props.networkParam,
          onClose: _cache[6] || (_cache[6] = ($event: any) => (showLoadWorkspaceFromTxDialog.value = false))
        }, null, 8, ["show", "workspace", "tx", "txField", "networkParam"])
      ]),
      _: 1
    })
  ], 64))
}
}

})